<div class="content content-md" style="overflow:hidden">
    <div class="scroll-content-nosearch" >
    <div id="content-list" class="list list-md" >
      <div class="item item-md list-header list-header-md" style="background-color: rgb(209, 91, 91);">
            <div class="item-inner">
                <div class="input-wrapper" style="width: 100%; text-align: center;">
                    <label class="label label-md" style="width: 100%;color: #fff;">{{getLabelTranslation("restricted")}}</label>
                </div>
            </div>
      </div>
</div>
